import React, { Fragment } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { PID_URL } from "../../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { setPidTabsSuccess } from "../../../../core/events/pidEvents";
import { setPidTabsLocalStorage } from "../../../../core/storage/localStorage";

function PIDFilesList({ files }) {
  return (
    <Box flex={1} overflow={"auto"}>
      <Typography variant="h6">PID Files</Typography>
      <Box mb={2} />
      <Box>
        {files.map((file, index) => (
          <Fragment key={file.id}>
            <PIDFileItem file={file} />
            <Divider sx={{ my: 0.5 }} />
          </Fragment>
        ))}
      </Box>
    </Box>
  );
}

function PIDFileItem({ file }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { tabs } = useSelector((state) => state.pid);

  const handleSelectFile = () => {
    let queryParams = new URLSearchParams();
    queryParams.set("fileId", file.id);
    const tab = { id: uuidv4(), file};
    queryParams.set("tabId", tab.id);
    dispatch(setPidTabsSuccess([...tabs, tab]));
    setPidTabsLocalStorage([...tabs, tab]);
    history.push(`${PID_URL}?${queryParams.toString()}`);
  };

  return (
    <Box
      p={1}
      borderRadius={2}
      sx={{
        cursor: "pointer",
        "&:hover": { backgroundColor: "action.hover" },
      }}
      onClick={handleSelectFile}>
      <Typography variant="body1">{file.name}</Typography>
    </Box>
  );
}

export default PIDFilesList;
